function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import lh from "react-lazy-hydration";
import React from "react";
var LazyHydrate = process.env.NODE_ENV === "test" ? function(_param) {
    var whenIdle = _param.whenIdle, whenVisible = _param.whenVisible, className = _param.className, style = _param.style, noWrapper = _param.noWrapper, children = _param.children, rest = _objectWithoutPropertiesLoose(_param, [
        "whenIdle",
        "whenVisible",
        "className",
        "style",
        "noWrapper",
        "children"
    ]);
    if (noWrapper) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    return /*#__PURE__*/ React.createElement("div", _extends({
        className: className
    }, Object.assign({}, rest, style ? {
        style: style
    } : {
        style: null
    })), children);
} : lh;
export default LazyHydrate;
